import cn from "@/util/cn";
import { ComponentPropsWithoutRef } from "react";

type PageHeaderProps = {
  title?: string;
} & ComponentPropsWithoutRef<"h1">;

/**
 * When setting the title to undefined, the title is fully removed and does not
 * take up space. If the title is an empty string, it does take up space.
 */
const PageHeader = ({ title, className }: PageHeaderProps) => (
  <h1
    className={cn("text-4xl font-bold text-primary/90", title === "" ? "opacity-0" : "", className)}
  >
    {title === "" ? "_" : title}
  </h1>
);

export default PageHeader;
